module.exports = __webpack_public_path__ + "img/back04_sp.8ff9f571.jpg";